import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import CreateGroupModal from './CreateGroupModal';

export default class SocialGroupsList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    
    // 初始化组件状态
    this.groups = [];
    this.isLoading = false;
    this.error = null;
    
    // 分页相关状态（保留用于兼容性，但不再使用分页功能）
    this.groupsMeta = {
      total: 0,
      page: 1,
      limit: 0,
      total_pages: 1,
      has_next_page: false,
      has_prev_page: false
    };
    
    // 加载群组数据
    this.loadGroups();
  }

  async loadGroups() {
    this.isLoading = true;
    this.error = null;
    
    try {
      // 一次性加载所有数据，不进行分页
      const response = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/social-groups/frontend',
        headers: {
          'Content-Type': 'application/vnd.api+json',
        },
        params: {
          // 不传分页参数，或设置一个很大的 limit 值以获取所有数据
          limit: 10000
        }
      });
      
      if (response && response.data) {
        // 优化：直接使用 API 返回的数据，避免额外的详情请求
        // 假设 API 已经返回了足够的信息（成员数、评论数等）
        // 如果 API 没有返回成员列表，则使用已有的 member_count
        this.groups = response.data.map((group) => {
          // 如果 API 已经返回了成员信息，使用它；否则使用 member_count
          const members = group.members || [];
          
          return {
            id: group.id,
            name: group.name || app.translator.trans('tf-groups.forum.groups-list.unnamed-group'),
            description: group.description || '',
            memberCount: group.member_count || 0,
            coverImage: group.cover_image || null,
            privacy: group.privacy || 'public',
            isContainer: group.is_container || false,
            parentId: group.parent_id || null,
            parent: group.parent || null,
            children: group.children || [],
            contact: group.contact || null,
            createdAt: group.created_at,
            updatedAt: group.updated_at,
            // 优化：只使用 API 返回的成员数据，如果没有则使用空数组
            // 成员头像可以在用户点击查看详情时再加载
            members: members.slice(0, 5), // 只取前5个成员用于头像显示
            commentCount: group.comment_count || group.stats?.replies || 0,
            userStatus: group.user_status || null, // 保存用户状态信息
          };
        });
        
        // 更新分页信息（保留用于兼容性）
        this.groupsMeta = {
          total: this.groups.length,
          page: 1,
          limit: this.groups.length,
          total_pages: 1,
          has_next_page: false,
          has_prev_page: false
        };
      } else {
        this.groups = [];
        console.warn('No social groups data received from API');
      }
      
    } catch (error) {
      console.error('Error loading social groups:', error);
      this.error = error.message || app.translator.trans('tf-groups.forum.groups-list.load-error');
      this.groups = [];
    } finally {
      this.isLoading = false;
      m.redraw(); // 触发重新渲染
    }
  }


  oncreate(vnode) {
    super.oncreate(vnode);
  }

  onupdate(vnode) {
    super.onupdate(vnode);
  }

  onremove(vnode) {
    super.onremove(vnode);
  }

  className() {
    return 'SocialGroupsList';
  }

  view() {
    // 确保 groups 已初始化
    if (!this.groups) {
      return null;
    }

    // 根据状态渲染不同的内容
    if (this.isLoading) {
      return (
        <div className="social-groups-list">
          {this.renderLoading()}
        </div>
      );
    }

    if (this.error) {
      return (
        <div className="social-groups-list">
          {this.renderError()}
        </div>
      );
    }

    return (
      <div className="social-groups-list">
        {this.renderGroups()}
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="groups-loading">
        <div className="loading-spinner">
          <i className="fa-light fa-spinner fa-spin"></i>
        </div>
        <div className="loading-text">{app.translator.trans('tf-groups.forum.groups-list.loading')}</div>
      </div>
    );
  }

  renderError() {
    return (
      <div className="groups-error">
        <div className="error-icon">
          <i className="fa-light fa-exclamation-triangle"></i>
        </div>
        <div className="error-message">{this.error}</div>
        <button 
          className="btn btn-sm btn-primary retry-button" 
          onclick={() => this.loadGroups()}
        >
          {app.translator.trans('tf-groups.forum.groups-list.retry')}
        </button>
      </div>
    );
  }

  renderGroups() {
    return (
      <div className="groups-list-container">
      <div className="groups-list-header">
      <div className="groups-list-header-content">
        {(() => {
          const backgroundImage = app.forum.attribute('tf-groups.header-background-image');
          if (backgroundImage) {
            const imageUrl = backgroundImage.startsWith('http') 
              ? backgroundImage 
              : app.forum.attribute('baseUrl') + '/' + backgroundImage;
            return (
              <div className="groups-list-header-background">
                <img src={imageUrl} alt="Groups header" loading="lazy" />
              </div>
            );
          }
          return null;
        })()}
      </div>
    </div>
      <div className="groups-list">
        {/* 页面标题区域 */}
       
        
        {/* 卡片网格 */}
        {this.groups.length > 0 ? (
          <div className="groups-list-grid">
            {this.groups.map(group => this.renderGroupCard(group, group.id))}
          </div>
        ) : (
          <div className="no-groups">{app.translator.trans('tf-groups.forum.groups-list.no-groups')}</div>
        )}
        
      </div>
      </div>
    );
  }

  renderGroupCard(group, key) {
    // 截断描述文本，限制为3行
    const truncateDescription = (text, maxLength = 150) => {
      if (!text) return app.translator.trans('tf-groups.forum.groups-list.no-description');
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    };

    const coverImageUrl = group.coverImage 
      ? (group.coverImage.startsWith('http') ? group.coverImage : app.forum.attribute('baseUrl') + '/' + group.coverImage)
      : null;

    return (
      <div 
        className="group-card" 
        key={key}
        onclick={() => this.viewGroup(group)}
      >
        {/* 顶部图片区域 - 圆角 */}
        <div className="group-card-image" style={coverImageUrl ? {
          backgroundImage: `url(${coverImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        } : {}}>
          {!coverImageUrl && (
            <div className="group-card-image-placeholder">
              <i className="fa-light fa-user-group"></i>
            </div>
          )}
        </div>
        
        {/* 内容区域 - 白色背景 */}
        <div className="group-card-content">
          <div className="group-card-title-wrapper">
            <h3 className="group-card-title">{group.name || app.translator.trans('tf-groups.forum.groups-list.unnamed-group')}</h3>
            {/* 用户状态标签 */}
            {group.userStatus && this.renderUserStatusTag(group.userStatus)}
          </div>
          
          {/* 描述文字 - 限制3行 */}
          <div className="group-card-description">
            {truncateDescription(group.description)}
          </div>
          
          {/* 底部交互元素 */}
          <div className="group-card-footer">
            {/* 左侧：用户头像（重叠显示） */}
            <div className="group-card-avatars">
              {group.members && group.members.length > 0 ? (
                group.members.slice(0, 3).map((member, idx) => {
                  const user = member.user || member;
                  const userObj = user && typeof user === 'object' ? user : {
                    id: member.id || idx,
                    username: member.username || 'user',
                    displayName: member.display_name || member.username || 'User',
                    avatarUrl: member.avatar_url || null
                  };
                  
                  return (
                    <div 
                      key={userObj.id || idx} 
                      className="group-card-avatar"
                      style={{ zIndex: 10 - idx }}
                    >
                      {userObj.avatarUrl ? (
                        <img src={userObj.avatarUrl} alt={userObj.displayName || userObj.username} />
                      ) : (
                        <div className="group-card-avatar-placeholder">
                          {(userObj.displayName || userObj.username || 'U').charAt(0).toUpperCase()}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                // 如果没有成员数据，显示占位头像
                Array.from({ length: Math.min(group.memberCount || 0, 3) }).map((_, idx) => (
                  <div 
                    key={idx} 
                    className="group-card-avatar group-card-avatar-placeholder"
                    style={{ zIndex: 10 - idx }}
                  >
                    <i className="fa-light fa-user-group"></i>
                  </div>
                ))
              )}
            </div>
            
            {/* 右侧：指标 */}
            <div className="group-card-metrics">
              <div className="group-card-metric">
                <i className="fa-light fa-user-group"></i>
                <span>{group.memberCount || 0}</span>
              </div>
              <div className="group-card-metric">
                <i className="fa-light fa-comments"></i>
                <span>{group.commentCount || 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  viewGroup(group) {
    if (group.id) {
      // 跳转到群组详情页面
      m.route.set(app.route('groupDetail', { id: group.id }));
    }
  }

  showCreateGroupModal() {
    app.modal.show(CreateGroupModal);
  }

  /**
   * 根据用户状态渲染标签
   */
  renderUserStatusTag(userStatus) {
    if (!userStatus) {
      return null;
    }

    // 判断是否为组员：role 为 "member" 且 status 为 "approved"
    const isMember = userStatus.role === 'member' && userStatus.status === 'approved';
    
    // 判断是否为版主/管理员：role 为 "admin"
    const isModerator = userStatus.role === 'admin';

    if (isMember) {
      return (
        <span className="group-card-tag group-card-tag--joined">
          Joined
        </span>
      );
    }

    if (isModerator) {
      return (
        <span className="group-card-tag group-card-tag--moderator">
          Moderators
        </span>
      );
    }

    return null;
  }
}
